export async function getWalletConnectProviderDetail() {
    return {
        info: {
            walletId: 'walletConnectId',
            uuid: 'walletConnect',
            name: 'Wallet Connect',
            icon: await getIcon(),
        },
    };
}
const icons = {
    default: () => import('./wallet-connect-icon').then((m) => m.icon),
};
export function getIcon() {
    return icons.default();
}
//# sourceMappingURL=wallet-connect-provider-detail.js.map